import React from 'react'
import { DEFAULT_IMPORT_APP_JSON_CONFIG, ImportAppJSON, ImportAppJsonConfig } from './ImportAppJSON'
import { StringTableInput } from '../../StringTableInput'
import { Label } from '../../ui-primitives/label'
import { produce } from 'immer'
import {v4 as uuid} from 'uuid'
import { WistorVarName, WistorVarValue } from '../../../redux/pubsub'

export type ComponentConfig
  = {}
  | {
      appRef: ImportAppJsonConfig
      namespace: string
      io: ComponentIO
    }

type ComponentIO = { inputMaps: null | VarMap[], outputMaps: null | VarMap[] }
export type VarMap = [sourceName: WistorVarName, targetName: WistorVarName]
export type VarMapRecord = Record<VarMap[0], Record<VarMap[1], WistorVarValue>>

type State
  = StateNothingConfigured
  | StateOnlyAppJsonConfigured
  | StateMaybeComplete

type StateNothingConfigured = {}
type StateOnlyAppJsonConfigured = { appRef: ImportAppJsonConfig }
type StateMaybeComplete = { appRef: ImportAppJsonConfig, namespace: string, io: null | ComponentIO }

export function SetComponentConfig(props: {
  value: ComponentConfig | null | undefined
  onChange: (value: ComponentConfig) => void | Promise<void>
}): React.ReactNode {

  const [state, setState] = React.useState<State>(props.value ?? {})

  const {onChange} = props
  React.useEffect(() => {
    const shouldSave
      = state !== props.value
      && 'io' in state // probably want to do some form validation here

    if (shouldSave) {
      onChange(state)
    }
  }, [props.value, state, onChange])

  return (
    <div>
      <ImportAppJSON
        name='not needed?'
        value={'appRef' in state ? state.appRef : DEFAULT_IMPORT_APP_JSON_CONFIG}
        onChange={appRef => setState((prevState): State => {
          if (!appRef.appConfig) return {appRef} satisfies StateOnlyAppJsonConfigured

          return {
            appRef,
            namespace: `${appRef.appConfig.title}--${uuid()}`,
            io: {
              inputMaps: (appRef.appConfig.componentInputVarNames ?? []).map(inputName => ['', inputName]),
              outputMaps: (appRef.appConfig.componentOutputVarNames ?? []).map(outputName => [outputName, '']),
            },
          } satisfies StateMaybeComplete
        })}
      />
      {'io' in state && state.io && (
        <div>

          {state.io.inputMaps && (
            <div>
              <Label>Input mapping</Label>
              <StringTableInput cannotDeleteRows
                key={state.namespace} // reinit config when namespace changes
                columnLabels={['app', 'input']}
                initialRows={state.io.inputMaps}
                disabledColumnIndexes={[1]}
                onChange={rows => setState(produce(draft => {
                  if (!('io' in draft && draft.io)) throw new Error('Oops! a developer made a mistake')
                  draft.io.inputMaps = rows
                }))}
              />
            </div>
          )}

          {state.io.outputMaps && (
            <div>
              <Label>Output mapping</Label>
              <StringTableInput cannotDeleteRows
                key={state.namespace} // reinit config when namespace changes
                columnLabels={['output', 'app']}
                initialRows={state.io.outputMaps}
                disabledColumnIndexes={[0]}
                onChange={rows => setState(produce(draft => {
                  if (!('io' in draft && draft.io)) throw new Error('Oops! a developer made a mistake')
                  draft.io.outputMaps = rows
                }))}
              />
            </div>
          )}

        </div>
      )}
    </div>
  )

}
